<template>
    <div>
        <div id="confirma-resultado" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Confirme a digitação do resultado</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div v-if="analise.tipo === 'SEMENTE'">
                                <div class="col-xs-12 col-md-4" v-if="analise.semente_germinacao">
                                    <div class="form-group">
                                        <label>Germinação (%)</label>
                                        <input type="text" v-model="analise.semente.germinacao" class="form-control" disabled/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-md-4" v-if="analise.semente_vigor">
                                    <div class="form-group">
                                        <label>Vigor (%)</label>
                                        <input type="text" v-model="analise.semente.vigor" class="form-control" disabled/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-md-4">
                                    <div class="form-group">
                                        <label>Pureza (%)</label>
                                        <input type="text" v-model="analise.semente.pureza" class="form-control" disabled/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-md-4">
                                    <div class="form-group">
                                        <label>Peso de mil sementes (gramas) </label>
                                        <input type="text" v-model="analise.semente.peso_mil_sementes" class="form-control" disabled/>
                                    </div>
                                </div>
                            </div>

                            <div v-if="analise.tipo === 'TECIDO'">
                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Nitrogênio (%)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.nitrogenio" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.nitrogenio_avaliacao" disabled></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Fósforo (%)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.fosforo" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.fosforo_avaliacao" disabled></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Potássio (%)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.potassio" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.potassio_avaliacao" disabled></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Cálcio (%)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.calcio" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.calcio_avaliacao" disabled></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Magnésio (%)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.magnesio" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.magnesio_avaliacao" disabled></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Enxofre (%)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.enxofre" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.enxofre_avaliacao" disabled></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Zinco (mg/kg)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.zinco" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.zinco_avaliacao" disabled></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Manganês (mg/kg)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.manganes" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.manganes_avaliacao" disabled></div>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Boro (mg/kg)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.boro" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.boro_avaliacao" disabled></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Sódio (mg/kg)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.sodio" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.sodio_avaliacao" disabled></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Ferro (mg/kg)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.ferro" class="form-control" disabled/></div>
                                        <div class="col-xs-4"><input type="text" class="form-control" v-model="analise.tecido.ferro_avaliacao" disabled></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline">
                                    <div class="row">
                                        <div class="col-xs-5">Cobre (mg/kg)</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.cobre" class="form-control" disabled/></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline" v-if="analise.tecido.desc_elemento_adicional_um != null && analise.tecido.desc_elemento_adicional_um != ''">
                                    <div class="row">
                                        <div class="col-xs-5">{{ analise.tecido.desc_elemento_adicional_um }}</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.vlr_elemento_adicional_um" class="form-control" disabled/></div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-6 form-inline" v-if="analise.tecido.desc_elemento_adicional_dois != null && analise.tecido.desc_elemento_adicional_dois != ''">
                                    <div class="row">
                                        <div class="col-xs-5">{{ analise.tecido.desc_elemento_adicional_dois }}</div>
                                        <div class="col-xs-3"><input type="text" v-model="analise.tecido.vlr_elemento_adicional_dois" class="form-control" disabled/></div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="analise.tipo === 'FERTILIZANTE'">
                                <div class="col-xs-12 col-md-4">
                                    <div class="form-group">
                                        <label>Nitrogênio (%)</label>
                                        <input type="text" v-model="analise.fertilizante.nitrogenio_resultado" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-md-4">
                                    <div class="form-group">
                                        <label>Fósforo (%)</label>
                                        <input type="text" v-model="analise.fertilizante.fosforo_resultado" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-md-4">
                                    <div class="form-group">
                                        <label>Potássio (%)</label>
                                        <input type="text" v-model="analise.fertilizante.potassio_resultado" class="form-control" disabled/>
                                    </div>
                                </div>
                            </div>

                            <div v-if="analise.tipo == 'SOLO' && analise.solo_quimica == 1">
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>pH</label>
                                        <input type="text" v-model="analise.solo.ph" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>SMP</label>
                                        <money v-model="analise.solo.smp" class="form-control" disabled></money>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Matéria orgânica (%)</label>
                                        <input type="text" v-model="analise.solo.materia_organica" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Fósforo (P) (mg/L)</label>
                                        <input type="text" v-model="analise.solo.fosforo" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Potássio (K) (mg/L) </label>
                                        <input type="text" v-model="analise.solo.potassio" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Fósforo Rem (P) (mg/L)</label>
                                        <input type="text" v-model="analise.solo.fosforo_rem" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Cálcio (Ca ²+) (cmol(c)/L)</label>
                                        <input type="text" v-model="analise.solo.calcio" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Magnésio (mg ²+) (cmol(c)/L)</label>
                                        <input type="text" v-model="analise.solo.magnesio" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Alumínio (Al ³+) (cmol(c)/L)</label>
                                        <input type="text" v-model="analise.solo.aluminio" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Hidrogênio + Al (cmol(c)/L)</label>
                                        <input v-model="analise.solo.hidrogenio_al" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Cobre (Cu)</label>
                                        <input type="text" onClick="this.select();" readonly v-model="analise.solo.cobre"
                                            class="form-control" data-vv-name="cobre"/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Zinco (Zn)</label>
                                        <input type="text" onClick="this.select();" readonly v-model="analise.solo.zinco"
                                                class="form-control" data-vv-name="zinco"/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Manganês (Mn)</label>
                                        <input type="text" onClick="this.select();" readonly v-model="analise.solo.manganes"
                                                class="form-control" data-vv-name="manganes"/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Boro (B)</label>
                                        <input type="text" onClick="this.select();" readonly v-model="analise.solo.boro"
                                                class="form-control" data-vv-name="boro"/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Enxofre (S)</label>
                                        <input type="text" onClick="this.select();" readonly v-model="analise.solo.enxofre"
                                                class="form-control" data-vv-name="enxofre"/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_ph_calc2">
                                    <div class="form-group">
                                        <label>Ph CaCl2</label>
                                        <input type="text" onClick="this.select();" readonly v-model="analise.solo.ph_cacl2"
                                                class="form-control" data-vv-name="ph_cacl2"/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_fosforo_resina">
                                    <div class="form-group">
                                        <label>Fósforo em resina</label>
                                        <input type="text" onClick="this.select();" readonly v-model="analise.solo.fosforo_resina"
                                                class="form-control" data-vv-name="fosforo_resina"/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_ferro">
                                    <div class="form-group">
                                        <label>Ferro (Fe)</label>
                                        <input type="text" onClick="this.select();" readonly v-model="analise.solo.ferro"
                                                class="form-control" data-vv-name="ferro"/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_silicio">
                                    <div class="form-group">
                                        <label>Silício (Si)</label>
                                        <input type="text" onClick="this.select();" readonly v-model="analise.solo.silicio"
                                                class="form-control" data-vv-name="silicio"/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_condutividade">
                                    <div class="form-group">
                                        <label>Condutividade (μS/cm)</label>
                                        <input type="text" v-model="analise.solo.condutividade" class="form-control" disabled/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4" v-if="analise.analisa_nitrogenio_azoto">
                                    <div class="form-group">
                                        <label>Nitrogenio Azoto</label>
                                        <input type="text" v-model="analise.solo.nitrogenio_azoto" class="form-control" disabled/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Sódio (Na) (%)</label>
                                        <input type="text" v-model="analise.solo.sodio" class="form-control" disabled/>
                                    </div>
                                </div>
                            </div>

                            <div v-if="analise.tipo === 'SOLO' && (analise.solo_fisica == 1 || analise.solo_quimica == 1)">
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Argila</label>
                                        <input type="text" v-model="analise.solo.argila" class="form-control" disabled/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4" v-if="analise.solo_fisica == 1">
                                    <div class="form-group">
                                        <label>Areia</label>
                                        <input type="text" v-model="analise.solo.areia" class="form-control" disabled/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4" v-if="analise.solo_fisica == 1">
                                    <div class="form-group">
                                        <label>Silte</label>
                                        <input v-model="analise.solo.silte" class="form-control" disabled/>
                                    </div>
                                </div>
                            </div>

                            <div v-if="analise.tipo === 'SOLO' && analise.solo_extrato_saturacao == 1">
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Condutividade (µs.cm-1)</label>
                                        <input type="text" v-model="analise.solo.condutividade_saturacao" class="form-control" disabled/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Alumínio (Al) (mg/L)</label>
                                        <input type="text" v-model="analise.solo.aluminio_saturacao" class="form-control" disabled/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12">
                                <hr style="border-top: 1px solid #80808033;">
                            </div>

                            <div class="col-xs-12">
                                <h4 v-if="analise.remetente.preco != null && analise.remetente.preco.imprime_resultado == '1'" class="text-danger">Resultado configurado para ser impresso.</h4>
                            </div>

                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>Informe o número de registro da análise</label>
                                    <input type="text" class="form-control" v-model="nroRegistro" autofocus/>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="modal-footer">
                        <div class="col-xs-12">
                            <div class="form-group">
                                <button type="button" class="btn btn-success" @click="confirmaResultado">Confirmar resultado</button>
                                <button type="button" class="btn btn-danger" data-dismiss="modal" @click="fechaModal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'confirma-resultado',
        props: [
            'analise',
            'callbackSucesso',
        ],
        components: {},
        data() {
            return {
                nroRegistro: ''
            }
        },
        methods: {
            fechaModal() {
                $("#confirma-resultado").modal('hide')
            },
            confirmaResultado() {
                if(this.analise.registro == this.nroRegistro ){
                    $("#confirma-resultado").modal('hide')    
                    return this.callbackSucesso()
                } else {
                    return window.swal('Número de registro inválido', 'O número de registro informado é diferente da análise.', 'warning');
                }
            }
        },
        beforeDestroy() {},
        mounted() {}
    }

</script>